<template>
  <!-- Main Content -->
  <div class="page-wrapper">
    <div class="container-fluid">
      <!-- Title -->
      <div class="row heading-bg">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <h5 class="txt-dark">
            PF Form 5A
            <refresh-button @click="refreshData"></refresh-button>
          </h5>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default card-view">
            <div class="panel-wrapper collapse in">
              <div class="panel-body">
                <div class="row">
                  <div class="col-md-6">
                    <my-search
                      class="form-control"
                      :search="searchText"
                      placeholder="Search here..."
                      @searchData="search"
                    ></my-search>
                  </div>
                </div>
                <br />
                <div class="row">
                  <div class="col-md-3">
                    <my-select
                      @change="selectDivision"
                      :selection.sync="group"
                      :suggestions="groups"
                      :placeholder="`Select GROUP`"
                    >
                    </my-select>
                  </div>
                  <div class="col-md-3">
                    <my-select
                      :selection.sync="groupDivision"
                      :suggestions="groupDivisions"
                      :placeholder="`Select DIVISION`"
                    >
                    </my-select>
                  </div>
                </div>
                <br />
                <div class="row">
                  <div class="col-md-3">
                    <my-select
                      @change="updateMonth"
                      :selection.sync="month_id"
                      :suggestions="months"
                      placeholder="Select month"
                    ></my-select>
                  </div>
                  <div class="col-md-3">
                    <my-select
                      @change="updateMonth"
                      :selection.sync="year"
                      :suggestions="years"
                      placeholder="Select year"
                    ></my-select>
                  </div>
                  <div class="col-md-4">
                    <button
                      class="btn btn-primary"
                      @click="searchData('generate')"
                    >
                      Generate</button
                    >&nbsp;&nbsp;
                    <button class="btn btn-success" @click="generatePDF">
                      Save & Print
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Row -->
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default card-view">
            <div class="panel-wrapper collapse in">
              <div class="panel-body">
                <errors :data="errors" />

                <div class="table-wrap" v-if="showForm5aTable"></div>
                <section id="mydiv" v-if="showForm5a">
                  <div v-if="PF_Calculations.length">
                    <div class="container-fluid">
                      <div class="col-lg-6 col-md-6 col-sm-4 col-xs-12">
                        <p style="font-weight: bold; font-size: 16px">
                          Name and address of the Factory / Establishment
                        </p>
                        <p>{{ site.name }}</p>
                        <p>{{ site.address }}</p>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-4 col-xs-12">
                        <h5 class="txt-dark">
                          <center style="font-weight: bold; font-size: 18px">
                            <p>Form No.5A</p>
                            <p>
                              The Employee's Provident Fund Scheme, 1952
                              [Paragraph 36(2)(a) and 36(2)(b)]
                            </p>
                            <p>
                              And Employee's Pension Scheme, 1955 [Para 20(4)]
                            </p>
                            <p>
                              Contribution Card for Currency Period From 1st
                              {{ month_name }} {{ year }} to 31st
                              {{ month_name }} {{ year }}
                            </p>
                          </center>
                        </h5>
                      </div>
                    </div>
                    <div class="container-fluid">
                      <div class="col-lg-6 col-md-6 col-sm-4 col-xs-12">
                        <br />
                        <br />
                        <br />
                        <br />
                        <p>Code No. of Factory / Estt.:</p>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-4 col-xs-12">
                        <p>RETURN OF ADDICTIONS FOR THE MONTH OF April 2020</p>
                        <p>
                          PART 'A'. Details of employee qualifying for
                          membership of
                        </p>
                        <p>Employee's provident Fund for the first time.</p>
                        <p style="font-size: 11px">
                          (To be sent to Commissioner with form No.2)
                        </p>
                      </div>
                    </div>
                    <div class="container-fluid">
                      <table
                        id="table-example-1"
                        class="table table-responsive col-md-10"
                      >
                        <thead>
                          <tr>
                            <th>Sr. No</th>
                            <th>Account No.</th>
                            <th>UAN No.</th>
                            <th>Name of the employees (in block letters)</th>
                            <th>father's name or husband's name</th>
                            <th>date of birth</th>
                            <th>sex</th>
                            <th>
                              date of eligibility for new member / date of
                              joining the estt. in case of old member
                            </th>
                            <th>
                              total period of Perivious service (excluding
                              period of breaks) as on the date of joining the
                              Fund
                            </th>
                            <th>
                              remarks: preivious A/c No. and particulars of
                              previous employer, if any, (if so whether he is a
                              member of family pension fund also)
                            </th>
                          </tr>
                          <tr>
                            <th>1</th>
                            <th>2</th>
                            <th>3</th>
                            <th>4</th>
                            <th>5</th>
                            <th>6</th>
                            <th>7</th>
                            <th>8</th>
                            <th>9</th>
                            <th>10</th>
                          </tr>
                        </thead>
                        <tbody>
                          <loading-table
                            :isLoading="isLoading"
                            cols="11"
                          ></loading-table>
                          <tr
                            v-for="(user, at) in PF_Calculations"
                            :key="`user${at}`"
                          >
                            <td>{{ serialNoStarting + at + 1 }}</td>
                            <td>{{ user.pf_no }}</td>
                            <td>{{ user.uan_no }}</td>
                            <td>{{ user.full_name }}</td>
                            <td>{{ user.father_name }}</td>
                            <td>{{ user.dob }}</td>
                            <td>{{ user.gender == 0 ? "Male" : "Female" }}</td>
                            <td>{{ user.joined_on }}</td>
                            <td></td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                      [Also fill in Part 'B' on reverse.]
                    </div>
                    <div class="container-fluid row">
                      <div class="col-lg-9 col-md-9 col-sm-4 col-xs-12"></div>
                      <div class="col-lg-3 col-md-3 col-sm-4 col-xs-12">
                        <br />
                        <br />
                        <hr />
                        <p>
                          Signature of the employer or other authorised officer
                        </p>
                        <p>and stamp of the factory / Establishment</p>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <h5>Register Not yet Generated</h5>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Row -->
    </div>
  </div>
  <!-- /Main Content -->
</template>

<script>
import html2pdf from "html2pdf.js";
import moment from "moment";
import axios from "axios";

export default {
  name: "PDFForm5A",
  data() {
    return {
      date_of_payment: "",
      isLoading: false,
      isSaving: false,
      users: [],
      month_id: "",
      month_name: "",
      year: "",
      months: [],
      years: [
        { id: 2020, name: 2020 },
        { id: 2021, name: 2021 },
        { id: 2022, name: 2022 },
        { id: 2023, name: 2023 },
        { id: 2024, name: 2024 },
        { id: 2025, name: 2025 },
      ],
      configurations: [],
      group: "",
      groupDivision: "",
      groups: [],
      groupDivisions: [],
      selectedCategories: [],
      searchText: "",
      serialNoStarting: 0,
      showForm5aTable: false,
      showForm5a: false,
    };
  },
  mounted() {
    this.getMonths();
    this.getMasters();

    // this.month_id = moment().format('M')
    // this.month_name = moment().format('MMMM')
    this.year = moment().format("Y");
  },
  methods: {
    getMonths() {
      let months = moment.months();
      months.forEach((month, m) => {
        this.months.push({
          id: m + 1,
          name: month,
        });
      });
    },
    updateMonth() {
      this.month_name = moment(this.month_id, "M").format("MMMM");
      this.totalDaysInMonth = moment(
        this.year + "-" + this.month_id,
        "YYYY-M"
      ).daysInMonth();
    },
    async getMasters() {
      let masters = await axios.get("/monthly_salaries/masters");
      masters = masters.data;

      this.configurations = masters.configurations;
      this.categories = masters.categories;
      this.groups = masters.groups;
      this.refreshData();
    },
    selectDivision() {
      this.groupDivision = "";
      this.isGenerateSalaryForAll = false;
      let group = this.groups.find((group) => group.id == this.group);
      this.groupDivisions = [];
      group.group_divisions.forEach((groupDivision) => {
        this.groupDivisions.push({
          id: groupDivision.id,
          name: groupDivision.division_name,
        });
      });
    },
    refreshData() {
      // this.month_id = ''
      this.searchText = "";
      this.group = "";
      this.groupDivision = "";
      this.searchData();
    },
    // This function is called when we search from search text
    search(searchText) {
      this.searchText = searchText;
      this.searchData();
    },
    searchData(source = "") {
      this.showForm5a = false;
      this.showForm5aTable = false;
      this.getData(source);
    },
    async getData(source) {
      try {
        this.isLoading = true;
        this.users = [];
        this.PF_Calculations = [];
        let PF_Calculations = await axios.get(
          `/pf_register/Form5A?monthId=${this.month_id}&year=${this.year}&groupId=${this.group}&groupDivisionId=${this.groupDivision}`
        );
        this.PF_Calculations = PF_Calculations.data.data;
        this.site = PF_Calculations[0].sites[0];
        let users = await axios.get(
          `/user_punches/filter?monthId=${this.month_id}&year=${this.year}&groupId=${this.group}&groupDivisionId=${this.groupDivision}`
        );
        this.users = [];
        users.data.data.forEach((user) => {
          if (
            user.employee_status == null ||
            (user.employee_status.code != "LEFT" &&
              user.employee_status.code != "TERMINATE")
          )
            this.users.push(user);
        });
        for (const user of this.users) {
          if (user.monthly_salary == null)
            this.initializeEmptyMonthlySalary(user);
          else this.getEarnedSalaryComponents(user);
        }
      } catch (e) {
        this.isLoading = false;
      }
      if (source == "search") {
        this.showForm5aTable = true;
        this.showForm5a = false;
      }
      if (source == "generate") {
        this.showForm5aTable = false;
        this.showForm5a = true;
      }
    },
    generatePDF() {
      var element = document.getElementById("mydiv");
      var opt = {
        margin: 0,
        filename: "PFForm5A.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: {
          unit: "mm",
          format: [280, 350],
          orientation: "portrait",
        },
      };
      html2pdf().set(opt).from(element).save();
    },
  },
};
</script>
